import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '../auth/AuthContext'
import { ProtectedRoute } from '../components/ProtectedRoute'
import { Layout } from '../components/Layout'
import { Settings } from '../pages/Settings';
import Adventure  from '../pages/Adventure'
import Character  from '../pages/Character'
import Inventory  from '../pages/Inventory'
import AuthPage   from '../pages/AuthPage'
import ShopPage from '../pages/Shop';
import GatheringPage from '../pages/Gathering';
import ProcessingPage from '../pages/Processing';
import Crafting from '../pages/Crafting';
import LeaderboardPage from '../pages/Leaderboard';
import DungeonPage from '../pages/Dungeon';
import StablePage from '../pages/Stable';
import Tavern from '../pages/Tavern';
import Treasury from '../pages/Treasury';
import Duel from '../pages/Duel';
import Raid from '../pages/Raid';
import Sleep from '../pages/Sleep';
import Staking from '../pages/Staking';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* public */}
          <Route path="/login" element={<AuthPage />} />

          {/* protected */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/adventure" element={<Adventure />} />
              <Route path="/character" element={<Character />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/shop" element={<ShopPage />} />   
              <Route path="/gathering" element={<GatheringPage />} />
              <Route path="/processing" element={<ProcessingPage />} />
              <Route path="/crafting" element={<Crafting />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="dungeon" element={<DungeonPage />} />
              <Route path="Stable" element={<StablePage />} />
              <Route path="Tavern" element={<Tavern />} />
              <Route path="Treasury" element={<Treasury />} />
              <Route path="Duel" element={<Duel />} />
              <Route path="Raid" element={<Raid />} />
              <Route path="Sleep" element={<Sleep />} />
              <Route path="Staking" element={<Staking />} />
              {/* …other protected pages */}
            </Route>
          </Route>

          {/* fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
